export const SentimentEnum = {
    VERY_NEGATIVE: 'Very Negative',
    NEGATIVE: 'Negative',
    NEUTRAL: 'Neutral',
    POSITIVE: 'Positive',
};
